<template>
    <div style="
      width: 100%;
      height: 100%;
      background: linear-gradient(rgb(121 104 191), #f5b8bf);
    ">
        <div class="mainWrap">
            <div class="mainBar" :style="{ backgroundImage: 'url(' + bannerBg + ')' }">
                <headerWX class="headerWX"></headerWX>
                <div class="hallWrap">
                    <div class="tit">
                        <div>
                            <img v-if="isMyBox" src="../../assets/imgs/JewelryBox/MyBox.png" alt="" />
                            <img v-else src="../../assets/imgs/JewelryBox/AllBox.png" alt="" />
                        </div>

                        <div class="BoxBtn">
                            <img v-if="isMyBox" @click="Boxswitch(false)"
                                src="../../assets/imgs/JewelryBox/AllBoxBtn.png" alt="" />
                            <img v-else @click="Boxswitch(true)" src="../../assets/imgs/JewelryBox/MyBoxBtn.png"
                                alt="" />
                        </div>
                    </div>
                    <div class="select">
                        <el-select v-model="type" placeholder="请选择" @change="TyprAlter">
                            <el-option label="情侣戒指" value="WeddingRing"></el-option>
                            <el-option label="闺蜜戒指" value="SisterWeddingRing"></el-option>
                            <el-option label="个人戒指" value="SingleRing"></el-option>
                        </el-select>
                        <el-input class="BoxName" placeholder="请输入内容" v-model="BoxName">
                            <template #suffix>
                                <i class="el-icon-search" @click="handleSearch"></i>
                            </template>
                        </el-input>
                    </div>
                    <div class="body" v-if="JewelryList.length == 0 ? false : true">
                        <div class="ring_body" v-if="Jewelrysingle == null ? false : true">
                            <div class="box">
                                <img class="box" src="../../assets/imgs/JewelryBox/jewelryBox.png" alt="" />
                                <img class="flicker" src="../../assets/imgs/JewelryBox/flicker.png" alt="" />
                                <img class="JewelryBox" :src="Jewelrysingle.ringImg" alt="" />
                                <img class="petal" src="../../assets/imgs/JewelryBox/2.webp" alt="" />
                            </div>

                            <div class="name">{{ Jewelrysingle.ringName }}</div>
                            <div v-if="!isMyBox" class="tit">{{ Jewelrysingle.remark }}</div>
                            <div v-if="isMyBox" style="display: flex; flex-direction: column; gap: 10px">
                                <img v-if="Jewelrysingle.status == 0" @click="clickWear(1)" class="wear"
                                    style="z-index: 10; position: relative" src="../../assets/imgs/JewelryBox/wear.png"
                                    alt="" />
                                <img v-else-if="Jewelrysingle.status == 1" class="wear"
                                    src="../../assets/imgs/JewelryBox/yeswear.png" alt="" />
                                <img v-if="Jewelrysingle.status == 1 && type == 'SingleRing'" class="wear"
                                    src="../../assets/imgs/JewelryBox/RemoveBtn.png" @click="clickWear(-1)" />
                            </div>
                            <img v-if="isWear" class="fireworks" src="../../assets/imgs/JewelryBox/fireworks.gif"
                                alt="" />
                        </div>
                        <div class="list_body">
                            <div class="list">
                                <div :class="['item', { active: isActive == item.ringSN }]"
                                    v-for="(item, index) in JewelryList" @click="list_item(item)" :key="item.ringSN">
                                    <span :title="item.ringName">{{ item.ringName }}</span>
                                    <div class="img">
                                        <img :src="item.ringImg" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div class="pagination">
                                <el-pagination :background="true" :page-size="16" :pager-count="5"
                                    layout="prev, pager, next" :current-page="currentPage" :total="count"
                                    @current-change="pagination" :hide-on-single-page="true">
                                </el-pagination>
                            </div>
                        </div>
                    </div>

                    <div class="nobody" v-else>
                        <img src="../../assets/imgs/JewelryBox/nobody.png" alt="" />
                    </div>
                </div>
            </div>
            <footerWX></footerWX>

            <!-- 二次确认弹窗 -->
            <!-- <div id="mask" v-if="ispopUp">
                <div
                    style=" position: fixed; top: 13%; left: 35%; border-radius: 10px ;width: 30vw; height: 70vh; min-width: 600px; padding: 5px; background: linear-gradient(#d7b7ff, #f9f8ff); z-index: 9999; ">
                    <popUp @ispopUp="TzpopUp" propShow="3" :DBF_goShop="DBF_goShop"></popUp>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
// import menuWX from '@/components/Menu'
import axios from "axios";
import Cookies from "js-cookie";
import headerWX from "@/components/Header";
import footerWX from "@/components/Footer";
// import popUp from "@/components/pop_up";

export default {
    name: "midAutumn",
    components: {
        // menuWX,
        headerWX,
        footerWX,
        // popUp,
    },
    data() {
        return {
            // 背景
            bannerBg: require("@/assets/imgs/JewelryBox/bannerBg.png"),
            //戒指类型
            type: "WeddingRing",
            BoxName: "",
            //点击
            isActive: null,

            //点击佩戴
            isWear: false,

            //戒指总数
            count: null,
            //当前所在页数
            currentPage: 1,

            //总的列表
            textJewelryList: [],
            //渲染的列表
            JewelryList: [],
            //搜索列表
            SearchList: [],
            //单个显示的戒指
            Jewelrysingle: null,

            // 是非是我的戒指盒还是全部戒指
            isMyBox: true,
        };
    },
    created() { },
    mounted() {
        this.list(this.type);
        document.documentElement.scrollTop = 0;
    },
    methods: {
        // 我的首饰盒  首饰图鉴切换
        // -------------------------start---------------------------------
        //点击切换按钮
        Boxswitch(boll) {
            if (this.isMyBox == boll) {
                return;
            } else {
                this.isMyBox = boll;
                this.list(this.type);
            }
        },

        // -------------------------end---------------------------------

        //点击item
        list_item(item) {
            this.isActive = item.ringSN;
            this.Jewelrysingle = item;
        },

        // 点击佩戴  卸下戒指  --- 个人可用
        clickWear(flag) {
            if (this.isWear == false) {
                axios({
                    method: "post",
                    url: "/ring/doWearRing",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        flag: flag, // 1佩戴  -1 卸下
                        ringSN: this.Jewelrysingle.ringSN,
                        platForm: "web",
                        ringTypes: this.type,
                        userId: Cookies.get("wx_userId"), // userId
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            //重新调用
                            this.list(this.type, "Wear");

                            if (flag == 1) {
                                this.isWear = true;
                                setTimeout(() => {
                                    this.isWear = false;
                                }, 3000);
                            }

                            this.$message.success(res.data.message);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    });
            } else {
                console.log("请勿连续点击");
            }
        },

        // 点击分页
        pagination(e, search) {
            this.currentPage = e;

            if (search) {
                this.JewelryList = this.SearchList.slice((e - 1) * 16, e * 16);
                // this.list(this.type)
            } else {
                this.JewelryList = this.textJewelryList.slice((e - 1) * 16, e * 16);
            }
        },
        //模糊查询
        handleSearch() {
            if (!Array.isArray(this.textJewelryList) || !this.BoxName) {
                this.count = this.textJewelryList.length;
                this.pagination(1);
                return [];
            }

            const regex = new RegExp(this.BoxName, "");

            this.SearchList = this.textJewelryList.filter((ring) =>
                regex.test(ring.ringName),
            );
            this.count = this.SearchList.length;
            this.pagination(1, "search");
        },

        //戒指类型选择
        TyprAlter() {
            this.BoxName = "";
            this.isActive = null;
            this.currentPage = 1;
            this.list(this.type);
        },

        //带上戒指
        PutOnTheRing() { },

        //戒指列表
        list(ringTypes, Wear) {
            if (this.isMyBox) {
                // 我的戒指  my
                axios({
                    method: "post",
                    url: "/ring/getRingLists",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        platForm: "web",
                        ringTypes: ringTypes,
                        ringName: this.BoxName,
                        userId: Cookies.get("wx_userId"), // userId
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            this.count = res.data.data.count;
                            this.textJewelryList = res.data.data.ringResponseList;
                            this.pagination(this.currentPage);

                            // 重新给单个显示的戒指赋值
                            if (Wear == "Wear") {
                                this.JewelryList.forEach((item) => {
                                    if (item.ringSN == this.Jewelrysingle.ringSN) {
                                        this.Jewelrysingle = item;
                                    }
                                });
                            }
                            if (res.data.data.currentRingResponse !== null) {
                                this.Jewelrysingle = res.data.data.currentRingResponse;
                                this.isActive = this.Jewelrysingle.ringSN;
                            } else {
                                this.Jewelrysingle = null;
                            }
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    });
            } else {
                //图鉴  all
                axios({
                    method: "post",
                    url: "/ring/getAllRingLists",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        platForm: "web",
                        ringTypes: ringTypes,
                        ringName: this.BoxName,
                        userId: Cookies.get("wx_userId"), // userId
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            this.count = res.data.data.count;
                            this.textJewelryList = res.data.data.ringResponseList;
                            this.pagination(this.currentPage);

                            // 重新给单个显示的戒指赋值
                            if (Wear == "Wear") {
                                this.JewelryList.forEach((item) => {
                                    if (item.ringSN == this.Jewelrysingle.ringSN) {
                                        this.Jewelrysingle = item;
                                    }
                                });
                            }
                            if (res.data.data.currentRingResponse !== null) {
                                this.Jewelrysingle = res.data.data.currentRingResponse;
                                this.isActive = this.Jewelrysingle.ringSN;
                            } else {
                                this.Jewelrysingle = null;
                                this.isActive = null;
                            }
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    });
            }
        },
    },
};
</script>

<style lang="less" scoped>
@media (max-width: 1440px) {
    .mainWrap {
        zoom: 0.75;
    }
}

@media (max-width: 1208px) {
    .mainWrap {
        zoom: 0.6;
    }
}

.headerWX {
    margin: 0;

    /deep/ .header {
        // background: #0c0c0c4f;
        background: rgba(116, 81, 255, 0.8);
        color: #fff;
    }
}

#mask {
    width: 100%;
    height: 100%;
    // opacity: 0.6;
    background-color: rgba(0, 0, 0, 0.8);
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 999;
}

.mainWrap {
    margin: auto;
    max-width: 1900px;
    min-width: 1900px;
    min-height: 100vh;
    background: linear-gradient(#fde9e2, #f5b8bf);
    // background-image: url("../../assets/imgs/Halloween/bannerBg.png");

    .mainBar {
        color: #333333;
        height: 1124px;
        background-size: 100% 100%;
        /* 使背景图像覆盖整个区域 */
        // background-position: center;
        /* 居中显示 */
        width: 100%;
        position: relative;
    }
}

.hallWrap {
    // min-height: 100vh;
    width: 70%;
    height: 950px;
    background: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(10px);
    margin: 20px auto;
    // padding-bottom: 20px;
    position: relative;

    .tit {
        width: 100%;
        text-align: center;
        position: relative;

        .BoxBtn {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 50px;
        }
    }

    .select {
        display: flex;
        justify-content: space-evenly;
        margin-bottom: 30px;

        /deep/.el-input__inner {
            border-color: #a042ff;
            border-radius: 20px;
        }

        .BoxName {
            width: 220px;
        }

        /deep/.el-input__suffix {
            display: flex;
            align-items: center;
            width: 30px;
            cursor: pointer;

            .el-input__suffix-inner {
                width: 100%;
                color: #000;
                font-size: 22px;
            }
        }
    }

    .body {
        display: flex;
        // height: 460px;
        justify-content: center;

        .ring_body {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            position: relative;

            .box {
                position: relative;
                animation: float 3s ease-in-out infinite;

                .JewelryBox {
                    position: absolute;
                    top: 38%;
                    left: 29%;
                    width: 100px;
                }

                @keyframes float {

                    0%,
                    100% {
                        transform: translateY(0);
                    }

                    50% {
                        transform: translateY(-5px);
                    }
                }

                .flicker {
                    position: absolute;
                    top: -15%;
                    left: -35%;
                    width: 350px;
                    /* 旋转动画 */
                    animation: rotate 2s linear infinite;
                }

                @keyframes rotate {
                    from {
                        transform: rotate(0deg);
                    }

                    to {
                        transform: rotate(360deg);
                    }
                }

                .petal {
                    position: absolute;
                    width: 300px;
                    left: -35%;
                    top: -6%;
                }
            }

            .name {
                margin: 20px;
                font-size: 20px;
                font-weight: 900;
            }

            .tit {
                font-size: 20px;
                font-weight: 900;
                color: #876ff5;
            }

            .wear {
                cursor: pointer;
                z-index: 9;
            }

            .fireworks {
                position: absolute;
                top: -100px;
            }
        }

        .list_body {
            width: 65%;

            .list {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                .item {
                    width: 18%;
                    margin: 13px 27px;
                    height: 130px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex-direction: column;
                    border: #a042ff 3px solid;
                    border-radius: 20px;
                    background: rgba(255, 255, 255, 0.747);
                    backdrop-filter: blur(10px);
                    cursor: pointer;

                    span {
                        height: 35%;
                        font-size: 16px;
                        width: 93%;
                        overflow: hidden;
                        text-align: center;
                        /* 居中 */
                        white-space: nowrap;
                        /* 必须用这个，不能用 text-wrap: nowrap */
                        text-overflow: ellipsis;
                        /* 省略号 */

                        /* 关键：删掉 flex，改用行高垂直居中 */
                        line-height: 42px;
                        /* 或者用下面万能居中法 */
                        display: block;
                    }

                    .img {
                        flex: 1;
                        width: 100%;
                        text-align: center;

                        img {
                            width: 50%;
                            max-height: 100%;
                            max-height: 75px;
                        }
                    }
                }

                .active {
                    background: #6a01ff3b;
                }
            }

            .pagination {
                margin: auto;

                .el-pagination {
                    text-align: center;
                }
            }
        }
    }

    .nobody {
        padding: 80px;
        text-align: center;
    }
}
</style>
